<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="state.fileUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :accept="accept"
      multiple
      :limit="limit"
      :on-exceed="handleExceed"
      :show-file-list="showFileList"
      v-model:file-list="list"
      :disabled="disabled"
      :headers="state.userInfo"
      :auto-upload="autoUpload"
      :on-change="handleChange"
      :list-type="listType"
      ref="RxkUploadFileRef"
    >
      <slot name="upload">
        <RxkButton :disabled="disabled" class="button" :icon="Upload">{{ btnName }}</RxkButton>
      </slot>
      <template #[item]="{ file }" v-for="item in Object.keys(omit($slots, 'upload'))">
        <slot :name="item" :file="file" />
      </template>
    </el-upload>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, PropType, onMounted } from 'vue'
import { RxkButton } from '@/components/common/RxkButton'
import { getBasParams, getFileName } from '@/utils/tools'
import { Upload } from '@element-plus/icons-vue'
import globalEnv from '@/configs'
import { getToken } from '@/utils/auth'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { omit } from 'lodash-es'
const props = defineProps({
  limit: {
    type: Number,
    default: 2
  },
  accept: {
    type: String,
    default: ''
    // default: '.csv, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  },
  maxSize: {
    type: Number,
    default: 30
  },
  fileList: {
    type: Array,
    default: () => []
  },
  showFileList: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否自动上传
  autoUpload: {
    type: Boolean,
    default: true
  },
  listType: {
    type: String as PropType<'text' | 'picture' | 'picture-card'>,
    default: ''
  },
  btnName: {
    type: String,
    default: '上传附件'
  },
  uploadApi: {
    type: String,
    default: ''
  },
  isTipsAll: {
    type: Boolean,
    default: true
  }
})
console.log(useSlots(), '12312321321')
const list = ref<any[]>([])
const RxkUploadFileRef = ref()
const emit = defineEmits(['handleSuccess', 'startUpload', 'handleRemove', 'preview', 'change'])
const state = reactive({
  fileInfo: {
    name: ''
  },
  fileUpload: props.uploadApi || globalEnv.uploadApi,
  data: getBasParams({ pictureType: 'common' }),
  userInfo: {
    // ignoreCancelToken: true,
    Authorization: getToken()
  }
})
function beforeUpload(file: File) {
  if (isNullOrUndefOrEmpty(props.maxSize) || props.maxSize === 0) {
    emit('startUpload', file)
    return true
  } else {
    const size = props.maxSize * 1024 * 1024
    if (file.size > size) {
      ElMessage.warning(`上传文件不能大于${props.maxSize}M`)
      return false
    }
    if (props.accept) {
      const lastIndex = file.name.lastIndexOf('.')
      const acceptStyle = file.name.slice(lastIndex)
      if (!props.accept?.includes(acceptStyle)) {
        ElMessage.error(`只能选择${props.accept}格式`)
        return false
      }
    }
    emit('startUpload', file)
    return true
  }
}
function handleRemove(file: File, fileList: any[]) {
  emit('handleRemove', fileList, file)
}
function handlePreview(file: File) {
  console.log(file)
  emit('preview', file)
}
function handleExceed(files: File[], fileList: any[]) {
  ElMessage.warning(
    `当前限制选择 ${props.limit} 个文件，本次选择了 ${files.length} 个文件` +
      (props.isTipsAll ? `，共选择了 ${files.length + fileList.length} 个文件` : '')
  )
}
function handleChange(uploadFile: any, uploadFiles: any) {
  emit('change', uploadFile, uploadFiles)
}
function handleSuccess(res: any, file: File, fileList: any) {
  console.log('上传成功', res)
  console.log(fileList)

  // const responseData = decryptResponse(res)
  emit('handleSuccess', fileList, file, res)
}
// 清除
function handleClearFiles() {
  RxkUploadFileRef?.value?.clearFiles()
}
// 删除某一个文件
function handleRemoveUploadFile(file: { uid: string | number }) {
  if (list.value?.find?.(ele => ele.uid === file.uid)) {
    list.value.splice(
      list.value.findIndex(ele => ele.uid === file.uid),
      1
    )
  }
}
defineExpose({
  handleClearFiles,
  handleRemoveUploadFile,
  initPage
})

onMounted(() => {
  initPage()
})

function initPage() {
  nextTick(() => {
    // 回显
    list.value =
      props.fileList?.map((el: any) => {
        return {
          name: el?.name ? getFileName(el.name) : '',
          status: 'success',
          uid: new Date().getTime(),
          response: {
            data: [{ path: el.url || el.path || el, name: el.name }]
          },
          url: globalEnv.imgBaseUrl + (el.url || el.path || el)
        }
      }) || []
  })
}
</script>

<style scoped lang="scss">
.upload-demo {
  //overflow: hidden;
  //font-size: 0;

  :deep(.el-upload-list__item-name) {
    font-size: 12px;
  }

  :deep(.el-upload-list__item-info) {
    width: calc(100% - 70px);
  }

  :deep(.el-upload-list--text .el-upload-list__item-name) {
    line-height: 32px;
  }

  :deep(.el-upload) {
    margin-top: 2px;
    height: 28px;
  }
}

.button {
  height: 24px;
  padding: 0 11px;
  font-size: 12px;
}
</style>
